import { isHandledAuthFailure } from "shared/lib/session-expired"

const getClient = () => global.Rollbar

export const reportError = (error, extra) => {
  // @ts-ignore
  getClient()?.error(error, extra)
}

// For a boundary's `onError`: reports what it caught, except an auth
// failure the app already handled by redirecting to the login page.
export const reportBoundaryError = (error, extra) => {
  if (isHandledAuthFailure(error)) {
    return
  }

  reportError(error, extra)
}

export const reportInfo = (message, ...args) => {
  // @ts-ignore
  getClient()?.info(message, ...args)
}

export const setRollbarUser = (userId) => {
  // @ts-ignore
  getClient()?.configure({ payload: { userId } })
}
